import React from 'react';
import {
  Box,
  Chip,
  FormControlLabel,
  Grid,
  Paper,
  Stack,
  Switch,
  Typography,
} from '@mui/material';

function QuickDiscountControls({ billCredit, toggles }) {
  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 1.5, sm: 2 },
        mb: 3,
        borderColor: 'primary.light',
        bgcolor: 'rgba(25, 118, 210, 0.04)',
      }}
    >
      <Stack spacing={1.5}>
        <Box display="flex" justifyContent="space-between" alignItems="center" gap={1} flexWrap="wrap">
          <Box>
            <Typography variant="subtitle1">Quick discount controls</Typography>
            <Typography variant="body2" color="text.secondary">
              Toggle the common discounts before building the quote.
            </Typography>
          </Box>
          <Chip
            size="small"
            color={billCredit ? 'success' : 'default'}
            variant="outlined"
            label={billCredit ? '$50 bill credit qualifies' : '$50 bill credit not applied'}
          />
        </Box>
        <Grid container spacing={1.5}>
          {toggles.map((toggle) => (
            <Grid item xs={12} md={4} key={toggle.id}>
              <Paper
                variant="outlined"
                sx={{
                  p: 1.25,
                  height: '100%',
                  borderColor: toggle.checked ? 'success.dark' : 'divider',
                  bgcolor: toggle.checked ? 'rgba(46, 125, 50, 0.12)' : 'background.paper',
                }}
              >
                <Stack spacing={0.75}>
                  <FormControlLabel
                    sx={{ m: 0, alignItems: 'flex-start' }}
                    control={(
                      <Switch
                        checked={toggle.checked}
                        onChange={(event) => toggle.onChange(event.target.checked)}
                        color="success"
                      />
                    )}
                    label={(
                      <Box>
                        <Typography variant="subtitle2">{toggle.title}</Typography>
                        <Typography variant="caption" color="text.secondary">
                          {toggle.helper}
                        </Typography>
                      </Box>
                    )}
                  />
                  <Chip
                    label={toggle.checked ? toggle.activeLabel : toggle.inactiveLabel}
                    size="small"
                    color={toggle.checked ? 'success' : 'default'}
                    variant={toggle.checked ? 'filled' : 'outlined'}
                    sx={{ alignSelf: 'flex-start' }}
                  />
                </Stack>
              </Paper>
            </Grid>
          ))}
        </Grid>
        <Typography variant="caption" color="text.secondary">
          Pre-authorized bank payment discount. Customer must set up auto-pay after install. Service agreement may show $10 higher before PAB.
        </Typography>
      </Stack>
    </Paper>
  );
}

export default QuickDiscountControls;
